import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import styled from 'styled-components';
import { ChevronUp, ChevronDown, HouseProperty } from '@awaze/design-system.components.icon';
import { InputFacade } from '@awaze/design-system.components.input-facade';
import { Popover, usePopover } from '@awaze/design-system.components.popover';
import { pxToRems, rgbOpacity } from '@awaze/design-system.utils.react';
import { StyledContainerStyled, MobileBox, } from './search-form-composition.styles';
import { useSearchFormContext } from '../search-form.context';
export const StyledSelectDropdown = styled.select `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  appearance: none;
`;
const StyledBox = styled(MobileBox) `
  position: relative;
`;
const ListItemStyled = styled.div `
  padding: ${pxToRems(10)} ${pxToRems(24)};

  &[aria-selected='true'] div {
    color: ${({ theme }) => `${theme.ColorThemeSecondary700}`};
  }

  &:focus,
  &:hover {
    outline: none;
    position: relative;
    background: ${({ theme }) => `${rgbOpacity(theme.ColorThemeCtaPrimaryActive, 0.2)}`};
  }

  &[aria-selected='true'] {
    background: ${({ theme }) => `${rgbOpacity(theme.ColorThemeCtaPrimaryActive, 0.2)}`};
  }
`;
export const StyledContainer = styled.div `
  padding: ${pxToRems(8)} 0;
`;
export const AccommodationTypeSelector = () => {
    const { formHooks, translations, defaultConfig } = useSearchFormContext();
    const [accommodationOptions] = defaultConfig.accommodationType.options;
    const accommodationContainerRef = useRef(null);
    const { PopoverContainer, togglePopover, popoverProps } = usePopover();
    const handleItemOnClick = (item) => {
        // Reset destination values if accommodationtype changes
        formHooks.setValue('id', '');
        formHooks.setValue('destinationId', '');
        formHooks.setValue('destinationURL', '');
        formHooks.setValue('featureId', '');
        formHooks.setValue('destination', '');
        formHooks.setValue('accommodationType', item);
    };
    const selectedAccommodation = formHooks.getValues('accommodationType');
    const selectedDisplayText = accommodationOptions?.options?.filter((opt) => opt.value === selectedAccommodation)[0]?.text;
    return (_jsxs(_Fragment, { children: [_jsx(StyledContainerStyled, { ref: accommodationContainerRef, "data-ga": "select-accomodation-type", children: _jsxs(PopoverContainer, { block: true, children: [_jsx(InputFacade, { onClick: togglePopover, label: "accommodationType", icon: _jsx(HouseProperty, {}), iconLabel: "Accommodation", placeholder: translations.accommodationSelector.placeholder, isFullWidth: true, value: selectedDisplayText, hideLabel: true, selectorIcon: popoverProps.popoverVisible ? _jsx(ChevronUp, {}) : _jsx(ChevronDown, {}), clearButtonAriaLabel: translations.accommodationSelector.inputFacadeClearButtonAriaLabel }), _jsx(Popover, { placement: "bottom-start", offset: {
                                top: 16,
                            }, boxConfig: { padding: 0 }, popoverWidth: 320, ...popoverProps, disableFlip: true, children: _jsx(StyledContainer, { children: _jsx("ul", { children: accommodationOptions.options.map((item) => (_jsx(ListItemStyled, { tabIndex: 0, "aria-selected": item.value === selectedAccommodation, onClick: () => {
                                            if (item.value !== selectedAccommodation) {
                                                popoverProps.closePopover();
                                                handleItemOnClick(item.value);
                                            }
                                        }, children: item.text }, item.text))) }) }) })] }) }), _jsxs(StyledBox, { margin: [4, 4, 4], radius: 4, colourScheme: "white", padding: [0, 0, 0], shadow: 2, children: [_jsx(InputFacade, { onClick: null, label: "accommodationType", icon: _jsx(HouseProperty, {}), iconLabel: "Accommodation", placeholder: translations.accommodationSelector.placeholder, isFullWidth: true, value: selectedDisplayText, hideLabel: true, selectorIcon: popoverProps.popoverVisible ? _jsx(ChevronUp, {}) : _jsx(ChevronDown, {}), clearButtonAriaLabel: translations.accommodationSelector.inputFacadeClearButtonAriaLabel }), _jsx(StyledSelectDropdown, { onChange: (e) => handleItemOnClick(e.target.value), "aria-label": "select", value: formHooks.watch('accommodationType'), children: accommodationOptions.options.map((option, index) => (_jsx("option", { value: option.value, children: `${option.text}` }, `sortOption-${index}`))) })] })] }));
};
//# sourceMappingURL=accommodation-type-selector.js.map